import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  uploadModal: {
    maxWidth: "900px",
  },
  text: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "21px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    color: "#465869",
  },
  button: {
    border: "1px dashed #CCDEEE",
    borderRadius: "8px",
    padding: "25px 16px",
  },
  textButton: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#308CDB",
  },
  textButtonFormat: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#667085",
  },
  textButtonInfo: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "21px",
    color: "#667085",
  },
  filename: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#667085",
    marginLeft: "12px",
  },
  redColor: {
    color: "#F97066",
  },
  dropzone: {
    cursor: "pointer",
  },
  filesList: {
    marginTop: "12px",
    maxHeight: "200px",
    overflowY: "auto" as const,
    display: "flex",
    flexDirection: "column" as const,
    gap: "8px",
  },
  showFile: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#FCFCFD",
    borderRadius: "12px",
    paddingLeft: "16px",
  },
  showFileLeft: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  loadingMainDiv: {
    width: "100%",
    display: "flex !important",
    justifyContent: "center !important",
    alignItems: "center !important",
  },
  loadingContainer: {
    display: "flex",
    width: "80%",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "40px",
    alignSelf: "center",
  },
  loadingModal: {
    maxWidth: "580px",
  },
  loadingTitle: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "20px",
    color: "#308CDB",
    textAlign: "center",
  },
  loadingProgress: {
    width: "25% !important",
    height: "100% !important",
    color: "#308CDB",
  },

  loadingInformation: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    color: "#465869",
  },

  tryAgainButton: {
    color: "#308CDB",
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
  },
}));

export default styles;
